
import React from 'react';
import { userSettingsServices } from '../../store/services/settings.service';

const IMAGE_SIZE_LIMIT = 5; // Maximum size in MB
export const DEFAULT_IMAGE_SIZE = 1; // Default size in MB for image compression

export const ImageCompressRange = ({}) => {
    const [value, setValue] = React.useState(DEFAULT_IMAGE_SIZE);
    const [loading, setLoading] = React.useState(true);
    const debounceTimeout = React.useRef();

    React.useEffect(() => {
        userSettingsServices.get().then((res) => {
            if (res?.settings?.imageCustomSize) {
                setValue(parseFloat(res.settings.imageCustomSize));
            }
        }).finally(() => setLoading(false));
    }, []);

    const handleChange = (e) => {
        let newValue = parseFloat(e.target.value);
        if (newValue <= 0.1) newValue = 0.1;
        if (newValue >= IMAGE_SIZE_LIMIT) newValue = IMAGE_SIZE_LIMIT;
        setValue(newValue);
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            userSettingsServices.post({ imageCustomSize: newValue });
        }, 500); // 500ms debounce
    };

    return (
        <div>
            <label className="form-label fw-bold w-100 text-center">Compressione immagini</label>
            <label htmlFor="customRange" className="form-label">Se un’immagine supera questa dimensione, verrà automaticamente compressa alla dimensione selezionata quando la caricherai dopo aver modificato questo valore.</label>
            <input type="range" className="form-range" min="0" max={IMAGE_SIZE_LIMIT} step={0.1}
                value={value} id="customRange"
                onChange={handleChange} disabled={loading} />
            <output htmlFor="customRange" id="rangeValue" aria-hidden="true">{value}Mb</output>
        </div>
    );
}